export default "__VITE_PUBLIC_ASSET__9310621d__"